import BposStore from './schema/BposStore';
import { createStore } from 'satcheljs';

const initialBposStore: BposStore = {
    bposNavBarData: null,
};

const store = createStore<BposStore>('bposStore', initialBposStore)();
export default store;
